import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { Action } from 'redux';
import {
  UpdateReleaseError,
  LoadReleaseSuccess,
  UpdateField,
} from '../action-creators';
import { LOAD_RELEASE_SUCCESS } from '../actions';
import moment from 'moment';
import { getMinDate } from '@webapp/controllers/release/release-history/new-release-tab';
import { NoOp } from '@webapp/store/ui/action-creators';

export const validateReleaseDate = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, LoadReleaseSuccess>(LOAD_RELEASE_SUCCESS),
    mergeMap(async (action) => {
      const currentRelease = action.release;
      const releaseDate = action.release?.releaseDate;
      if (
        releaseDate &&
        currentRelease &&
        !currentRelease.isPublished &&
        currentRelease.backofficeStatus === undefined &&
        !moment(releaseDate)
          .startOf('day')
          .isSameOrAfter(moment().startOf('day'))
      ) {
        const minDate = getMinDate();
        const isValid = moment(releaseDate)
          .startOf('day')
          .isSameOrAfter(minDate);

        if (!isValid) {
          try {
            return new UpdateField<'releaseDate'>('releaseDate', undefined);
          } catch (err) {
            return new UpdateReleaseError(err.message);
          }
        }
      }
      return new NoOp();
    })
  );
